import { Rocket, PartyPopper, Target, GraduationCap, Scale, PiggyBank, Users, PawPrint, PersonStanding, Sun, Droplets, Smile, Clock, Palette, BookOpen } from "lucide-react";

// Plantillas educativas para niños (Modo Niños): emojis en las ramas y colores vivos.
export const KIDS_TEMPLATES = [
  {
    id: "kids-familia", name: "Mi familia 👨‍👩‍👧", icon: Users, kids: true,
    description: "Papá, mamá, hermanos, abuelos y mascota.",
    outline: `## 👨 Papá
## 👩 Mamá
## 🧒 Hermanos
## 👵 Abuelos
## 🐶 Mascota`,
  },
  {
    id: "kids-animales", name: "Los animales 🐾", icon: PawPrint, kids: true,
    description: "Conoce distintos animales.",
    outline: `## 🐶 Perro
## 🐱 Gato
## 🐦 Pájaro
## 🐟 Pez
## 🦁 León
## 🐘 Elefante`,
  },
  {
    id: "kids-cuerpo", name: "Partes del cuerpo 🧍", icon: PersonStanding, kids: true,
    description: "Aprende las partes del cuerpo.",
    outline: `## 👁️ Ojos
## 👂 Orejas
## 👃 Nariz
## 👄 Boca
## ✋ Manos
## 🦶 Pies`,
  },
  {
    id: "kids-solar", name: "El sistema solar 🪐", icon: Sun, kids: true,
    description: "El Sol, la Tierra y los planetas.",
    outline: `## ☀️ Sol
## 🌍 Tierra
## 🌙 Luna
## 🪐 Saturno
## ⭐ Estrellas`,
  },
  {
    id: "kids-agua", name: "El ciclo del agua 💧", icon: Droplets, kids: true,
    description: "Cómo viaja el agua en la naturaleza.",
    outline: `## ☀️ Evaporación
## ☁️ Condensación
## 🌧️ Precipitación
## 🌊 Ríos y mares`,
  },
  {
    id: "kids-emociones", name: "Las emociones 😀", icon: Smile, kids: true,
    description: "Reconoce cómo te sientes.",
    outline: `## 😀 Feliz
## 😢 Triste
## 😠 Enojado
## 😨 Asustado
## 😲 Sorprendido`,
  },
  {
    id: "kids-rutina", name: "Mi rutina diaria ⏰", icon: Clock, kids: true,
    description: "Mañana, tarde y noche.",
    outline: `## 🌅 Mañana
- Despertar
- Desayunar
- Ir a la escuela
## ☀️ Tarde
- Almorzar
- Tareas
- Jugar
## 🌙 Noche
- Cenar
- Bañarse
- Dormir`,
  },
  {
    id: "kids-colores", name: "Los colores 🎨", icon: Palette, kids: true,
    description: "Los colores y ejemplos.",
    outline: `## 🔴 Rojo
## 🔵 Azul
## 🟡 Amarillo
## 🟢 Verde
## 🟠 Naranja
## 🟣 Morado`,
  },
  {
    id: "kids-cuento", name: "Un cuento 📖", icon: BookOpen, kids: true,
    description: "Inicio, nudo y final de una historia.",
    outline: `## 🏁 Inicio
- ¿Quién?
- ¿Dónde?
## ⚡ Nudo
- ¿Qué problema pasa?
## 🎉 Final
- ¿Cómo se resuelve?`,
  },
];


// Plantillas guía (sin IA). El esquema se usa tal cual para notas y se
// convierte automáticamente a mapa mental para el tipo "mindmap".
export const TEMPLATES = [
  {
    id: "presupuesto",
    name: "Presupuesto",
    icon: PiggyBank,
    description: "Ingresos (verde), egresos (rojo) y haber (blanco).",
    outline: `## Ingresos
- Sueldo
- Ventas
- Otros ingresos

## Egresos
- Vivienda
- Alimentación
- Transporte
- Servicios

## Haber
- Total ingresos − Total egresos
- Ahorro del mes`,
  },
  {
    id: "proyecto",
    name: "Proyecto",
    icon: Rocket,
    description: "Objetivo, tareas, responsables y fechas.",
    outline: `## Objetivo
- ¿Qué quiero lograr?

## Tareas
- Primera tarea
- Segunda tarea

## Responsables
- ¿Quién hace qué?

## Fechas clave
- Inicio
- Entrega`,
  },
  {
    id: "evento",
    name: "Evento",
    icon: PartyPopper,
    description: "Boda, viaje o fiesta paso a paso.",
    outline: `## Fecha y lugar
- ¿Cuándo?
- ¿Dónde?

## Invitados
- Lista de personas

## Presupuesto
- Gasto 1
- Gasto 2

## Pendientes
- Reservar
- Confirmar`,
  },
  {
    id: "meta",
    name: "Meta / hábito semanal",
    icon: Target,
    description: "Define una meta y tu plan de la semana.",
    outline: `## Mi meta
- ¿Qué quiero mejorar?

## Días
- Lunes
- Martes
- Miércoles
- Jueves
- Viernes

## Recompensa
- ¿Cómo me premio al lograrlo?`,
  },
  {
    id: "estudio",
    name: "Estudio / resumen",
    icon: GraduationCap,
    description: "Resume un tema y aclara tus dudas.",
    outline: `## Tema principal
- Idea general

## Puntos clave
- Punto 1
- Punto 2
- Punto 3

## Dudas
- ¿Qué no entiendo?

## Resumen
- En mis palabras...`,
  },
  {
    id: "decision",
    name: "Pros y contras",
    icon: Scale,
    description: "Toma decisiones con claridad.",
    outline: `## Decisión
- ¿Qué debo decidir?

## Pros
- A favor 1
- A favor 2

## Contras
- En contra 1
- En contra 2

## Conclusión
- Mi elección`,
  },
];
